import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import StickyCTAs from '../components/StickyCTAs';
import { Box } from '@mui/material';

export default function MainLayout({ children }) {
  return (
    <Box>
      <Header />
      <main>{children}</main>
      <StickyCTAs />
      <Footer />
    </Box>
  );
}
